/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { DemandeSAVRequest } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DemandeSAVApi - axios parameter creator
 * @export
 */
export const DemandeSAVApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the SAV detail.
         * @summary Get the SAV detail
         * @param {string} storeId The store identifier.
         * @param {DemandeSAVRequest} demandeSAVRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandeSAV: async (storeId: string, demandeSAVRequest: DemandeSAVRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('demandeSAV', 'storeId', storeId)
            // verify required parameter 'demandeSAVRequest' is not null or undefined
            assertParamExists('demandeSAV', 'demandeSAVRequest', demandeSAVRequest)
            const localVarPath = `/store/{storeId}/resources/demandeSAV`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(demandeSAVRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemandeSAVApi - functional programming interface
 * @export
 */
export const DemandeSAVApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemandeSAVApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the SAV detail.
         * @summary Get the SAV detail
         * @param {string} storeId The store identifier.
         * @param {DemandeSAVRequest} demandeSAVRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async demandeSAV(storeId: string, demandeSAVRequest: DemandeSAVRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.demandeSAV(storeId, demandeSAVRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DemandeSAVApi - factory interface
 * @export
 */
export const DemandeSAVApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemandeSAVApiFp(configuration)
    return {
        /**
         * Get the SAV detail.
         * @summary Get the SAV detail
         * @param {string} storeId The store identifier.
         * @param {DemandeSAVRequest} demandeSAVRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandeSAV(storeId: string, demandeSAVRequest: DemandeSAVRequest, options?: any): AxiosPromise<void> {
            return localVarFp.demandeSAV(storeId, demandeSAVRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemandeSAVApi - object-oriented interface
 * @export
 * @class DemandeSAVApi
 * @extends {BaseAPI}
 */
export class DemandeSAVApi extends BaseAPI {
    /**
     * Get the SAV detail.
     * @summary Get the SAV detail
     * @param {string} storeId The store identifier.
     * @param {DemandeSAVRequest} demandeSAVRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandeSAVApi
     */
    public demandeSAV(storeId: string, demandeSAVRequest: DemandeSAVRequest, options?: any) {
        return DemandeSAVApiFp(this.configuration).demandeSAV(storeId, demandeSAVRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
